// utils/base64Utils.js

/**
 * Decodes a base64 string into a Uint8Array of bytes
 * @param {string} base64String
 * @returns {Uint8Array}
 */
export function decodeBase64ToBytes(base64String) {
    const binaryStr = atob(base64String);
    const bytes = new Uint8Array(binaryStr.length);
    for (let i = 0; i < binaryStr.length; i++) {
      bytes[i] = binaryStr.charCodeAt(i);
    }
    return bytes;
  }
  